/* eslint-disable reverb-design-system/prefer-components-to-classname */
import React from 'react';
import classNames from 'classnames';

type TagVariant = 'default' | 'highlight' | 'notification';

interface IRCTagProps {
  /**
   * `default` is a standard gray tag used mainly for optional labels in forms.
   *
   * `highlight` is used to call special attention to specific UIs.
   *
   * `notification` is used exclusively for things like new features, and cart/message counts.
   */
  variant?: TagVariant;

  /** Example: cart notifications. Small is helpful when space is tight. */
  small?: boolean;

  /** The content of the tag. */
  children: React.ReactNode;
}

export function RCTag({ variant = 'default', small, children }: IRCTagProps) {
  const classes = classNames(
    'rc-tag',
    { 'rc-tag--highlight': variant === 'highlight' },
    { 'rc-tag--notification': variant === 'notification' },
    { 'rc-tag--small': small },
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
}
